import React from 'react';
import MoesLogo from '../../assets/images/logo-white.png';
import Book from '../../components/Book/Book';
import Slogans from '../../components/Slogans/Slogans';
import classes from './HomePage.css';

const homepage = (props) => {
    

    return (
        <div className={classes.HomePage}>
            <img className={classes.Logo} src={MoesLogo} alt="Moes" />
            <Slogans />
            <Book />
           
        </div>
    );
}

export default homepage;





// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.js